import React, { useEffect, useState } from "react"
import { Col, Row } from "react-bootstrap"
import Link from "next/link"
import { WorkshopCardDiv, StyledHeader } from "../styled/StyledWorkshopCard"
import WorkshopCard from "./WorkshopCard"
import LoadMoreButton from "@modules/Common/styled/LoadMore"
import { StudentRegisteredWorkshopsQuery, useStudentRegisteredWorkshopsQuery } from "@generated/graphql"

export default function StudentRegisteredWorkShops() {
  const [skip, setSkip] = useState(0)
  const [take, setTake] = useState(8)
  const [isReachingEnd, setIsReachingEnd] = useState<boolean>(false)
  const [workshops, setWorkshops] = useState<StudentRegisteredWorkshopsQuery["studentRegisteredWorkshops"]>([])

  const { data: studentRegisteredWorkshopData, loading: studentRegisteredWorkshopLoading } = useStudentRegisteredWorkshopsQuery({
    fetchPolicy: "cache-and-network",
    notifyOnNetworkStatusChange: true
  })

  useEffect(() => {
    if (studentRegisteredWorkshopLoading === false && studentRegisteredWorkshopData && studentRegisteredWorkshopData?.studentRegisteredWorkshops) {
      if (studentRegisteredWorkshopData?.studentRegisteredWorkshops.length < take) {
        setIsReachingEnd(true)
      }
      setWorkshops([...workshops, ...studentRegisteredWorkshopData.studentRegisteredWorkshops])
    }
  }, [studentRegisteredWorkshopLoading, studentRegisteredWorkshopData])


  return <>
    {workshops.length > 0 && <>
      <div><StyledHeader>My Workshops</StyledHeader></div>
      <Row>
        {workshops.map((workshop, index) =>
          <Col
            lg={{ span: 3, offset: 0 }}
            sm={{ span: 4, offset: 0 }}
            xs={{ span: 12, offset: 0 }}
            key={index}
            className="p-3">
            <Link href={`/workshops/${encodeURIComponent(workshop.slug)}`} legacyBehavior>
              <WorkshopCardDiv>
                <WorkshopCard title={workshop.name} image={workshop.featuredImage || "/assets/img/logo.png"} />
              </WorkshopCardDiv>
            </Link>
          </Col>
        )}
      </Row>
      <Row className="justify-content-center">
        <Col className="col-auto">
          <LoadMoreButton
            disabled={studentRegisteredWorkshopLoading || isReachingEnd}
            onClick={() => {
              setTake(4)
              setSkip(workshops.length)
            }}>
            {studentRegisteredWorkshopLoading ? "LOADING..." : isReachingEnd ? "NO MORE WORKSHOPS" : "SHOW MORE"}
          </LoadMoreButton>
        </Col>
      </Row>
    </>
    }
  </>
}
